import TableHeader from '@/components/reusables/dashboard/TableHeader';
import { useFetchMostScannedProducts } from '@/hooks/dashboardHooks';
import { Box } from 'lucide-react';
import ProductRow from './ProductRow';
import { useNavigate } from 'react-router';

const TopScannedProducts = () => {
  const navigate = useNavigate();
  const { data: productData } = useFetchMostScannedProducts();

  return (
    <>
      <div className="d-full-card-wrap mb-0!">
        <TableHeader
          title="Top 5 Scanned Products"
          titleIcon={Box}
          className="mb-4"
          onViewAllButtonClick={() => navigate('/owner/reports?tab=scanned-products')}
        />

        <div className="product-qr-row-wrap max-h-100 overflow-auto">
          {productData && productData.length > 0 ? (
            productData.map((item: any, idx: any) => <ProductRow item={item} key={idx} />)
          ) : (
            <p className="text-center">No scanned products</p>
          )}
        </div>
      </div>
    </>
  );
};

export default TopScannedProducts;
